import { useState, useEffect } from 'react'
import {Pagination} from 'antd'
import useStore from 'base/store'
import {PROJECT_CATEGORY_NAME, ProjectCategory} from 'modules/project'
import {Loader} from 'common/components'
import {maybePluralize} from 'common/helpers'
import {
  // ProjectsStats,
  ProjectsList,
  ProjectsListPanel,
  useGet1PageProjects,
  uniqueUsersFromProjects,
  ProjectsProps,
  ProjectFilterItems,
} from '..'

export default function ClosedProjects() {
  /**
   * The projects data here is just useful for <ProjectsStats>
   * For we are going to hide <ProjectsStats>
   * The projects data is no useful any more
   */

  // const {data: projects} = useGetProjects({type: 'closed'})
  // if (!projects) return <Loader />
  // if (projects.length === 0)
  //   return (
  //     <Empty
  //       icon={<FolderBookmarkIcon width={40} height="100%" />}
  //       title="closed projects"
  //     />
  //   )

  return (
    <>
      {/* <ProjectsStats projects={projects} /> */}
      <Projects // projects={projects}
      />
    </>
  )
}

const Projects = ({projects = []}: ProjectsProps) => {
  const [pageNumber, setPageNumber] = useState(1)
  const role = useStore((state) => state.role)
  const filter = useStore((state) => state.closedProjectsFilter)
  const search = useStore((state) => state.closedProjectsSearch)
  const sort = useStore((state) => state.closedProjectsSort)
  const setFilter = useStore((state) => state.setClosedProjectsFilter)
  const setSearch = useStore((state) => state.setClosedProjectsSearch)
  const setSort = useStore((state) => state.setClosedProjectsSort)
  const querySort = sort
  .replace('maturity', 'maturityDate')
  .replace('desc', '-')
  .replace('asc', '')
  .replace(' ', '')
  const {data, isRefetching} = useGet1PageProjects({
    sort: querySort,
    filter,
    type: 'closed',
    search: search.trim(),
    pageNumber,
  })

  const filteredProjects: any[] | undefined = data?.data
  const closedProjects = filteredProjects || [] // ? filteredProjects : projects

  useEffect(() => {
    if (
      (!!filteredProjects) &&
      (filteredProjects.length === 0) &&
      (!!search) &&
      (!!data?.meta?.total)
    ) {
      setPageNumber(1)
    }
  })

  const regionsSet = new Set<string>(
    projects.map((project: any) => project.region)
  )

  const allCategories = projects.map((project: any) => project.categories)
  const categoriesSet = new Set<ProjectCategory>(allCategories.flat())

  const filterItems: ProjectFilterItems = {
    region: Array.from(regionsSet).map((region) => ({
      value: region,
      label: region,
    })),
    category: Array.from(categoriesSet).map((category) => ({
      value: category,
      label: PROJECT_CATEGORY_NAME[category],
      tip: maybePluralize(
        allCategories.reduce(
          (count, categories) =>
            categories.includes(category) ? count + 1 : count,
          0
        ),
        'project'
      ),
    })),
    borrower: uniqueUsersFromProjects(projects, 'borrower').map((borrower) => ({
      value: borrower.uuid,
      label: `${borrower.firstName} ${borrower.lastName}`,
      tip: borrower.displayId,
      image: borrower.photo,
    })),
    manager: role.manager
      ? undefined
      : uniqueUsersFromProjects(projects, 'manager').map((manager) => ({
          value: manager.uuid,
          label: `${manager.firstName} ${manager.lastName}`,
          tip: manager.displayId,
          image: manager.photo,
        })),
  }

  return (
    (!filteredProjects) ? <Loader />
    :
    <>
      <ProjectsListPanel
        type="closed"
        projectsCount={data.meta.total}
        filter={filter}
        filterItems={filterItems}
        search={search}
        setFilter={setFilter}
        setSearch={setSearch}
      />
      <ProjectsList
        isRefetching={isRefetching}
        type="closed"
        sort={sort}
        items={closedProjects}
        setSort={setSort}
      />
      <Pagination
        showSizeChanger={false}
        current={pageNumber}
        total={data?.meta?.total || 1}
        pageSize={10}
        onChange={setPageNumber}
      />
    </>
  )
}
